import CreatorProfile from "./CreatorProfile";

export default function EmeraldOnyxProfile() {
  return (
    <CreatorProfile
      creatorId={8}
      categoryLabel="Action Superhero"
      onlyMemberzSlug="emeraldonyx"
      tags={["Action", "Superhero", "Crossover", "Refs Of ILL"]}
    />
  );
}
